module.exports = __webpack_public_path__ + "img/edit-white.5e89e76b.svg";